const User = {
  state: () => ({
    user_info: {},
    friends_map: {}, // 好友map表
    top_friend_id: [], //置顶好友id
    once_tasks: [], //一次性任务列表
    blacklist: [], //用户黑名单ID
    invisible_list: [], //对x隐身列表
    friend_online_cnt: 0, //所有好友在线数量
    recommend_friends: [], //推荐好友列表
    recommend_friends_over: false, //推荐好友列表是否加载完成
    online_state: 1, //0隐身/1在线/5离开/6请勿打扰
    favorite_voice_pack_ids: [], //收藏的语音包id list(path)
    post_msg_unread: {
      award: 0,
      comment: 0,
      at: 0,
    }, // 帖子的赞、评论、艾特未读消息数量
    user_theme_setting: null, // 用户外观设置
    avatar_main_color: '', // 用户头像主色, 屏幕共享预览卡片底色使用
    bilibili_living: false, // 用户是否哔哩哔哩直播中(哔哩哔哩直播姬正在启动)
    laughter_blacklist: [], // 语音包黑名单
    mini_programs_folders: [], // 左上角收藏 + 推荐 小程序列表
    steam_id: "", // 账号绑定的steamid
    recent_mini_pro: [], // 用户最近使用的小程序

    user_verified_status: null, // 用户认证状态

  }),
  getters: {
    user_info: (state) => state.user_info,
    user_heybox_id: (state) => state.user_info.user_id,
    is_login: (state)=> Boolean(state.user_info.user_id),
    friends_map: (state) => state.friends_map,
    top_friend_id: (state) => state.top_friend_id,
    once_tasks: (state) => state.once_tasks,
    show_once_task_by_id: (state) => (type) => {
      const task = state.once_tasks.find(item => item.task_id == type)
      return task && (task.reachable == 1) && !task.finished
    },
    blacklist: (state) => state.blacklist,
    invisible_list: (state) => state.invisible_list,
    friend_online_cnt: (state) => state.friend_online_cnt,
    recommend_friends: (state) => state.recommend_friends,
    recommend_friends_over: (state) => state.recommend_friends_over,
    online_state: (state) => state.online_state,
    favorite_voice_pack_ids: (state) => state.favorite_voice_pack_ids,
    post_msg_unread: (state) => state.post_msg_unread,
    user_theme_setting: (state) => state.user_theme_setting,
    avatar_main_color: (state) => state.avatar_main_color,
    bilibili_living: (state, getters, rootState) => rootState.settings.global_config?.switches?.check_bilibili && state.bilibili_living,
    user_verified: (state) => !!state.user_info?.verified_info?.id_card,
    laughter_blacklist: (state) => state.laughter_blacklist,
    mini_programs_folders: (state) => state.mini_programs_folders,
    steam_id: (state) => state.steam_id,
    recent_mini_pro: (state) => state.recent_mini_pro,
    user_verified_status: (state) => state.user_verified_status,
  },
  mutations: {
    SET_USER_INFO (state, val) {
      state.user_info = {
        ...state.user_info,
        ...val
      }
    },
    SET_USER_HEYBOX_ID (state, val) {
      state.user_info.user_id = val
    },
    SET_FRIENDS (state, val) {
      state.friends_map = val
    },
    SET_TOP_FRIEND_ID(state, val) {
      state.top_friend_id = val
    },
    SET_ONCE_TASK_LIST(state, val) {
      state.once_tasks = val
    },
    SET_BLACKLIST(state, val) {
      state.blacklist = val
    },
    SET_INVISIBLELIST(state, val) {
      state.invisible_list = val
    },
    SET_FRIEND_ONLINE_CNT(state, val) {
      state.friend_online_cnt = val
    },
    SET_RECOMMEND_FRIENDS(state, val) {
      state.recommend_friends = val
    },
    SET_RECOMMEND_FRIENDS_OVER(state, val) {
      state.recommend_friends_over = val
    },
    SET_ONLINESTATE(state, val) {
      state.online_state = val
    },
    SET_FAVORITE_VOICE_PACK_IDS(state, val) {
      state.favorite_voice_pack_ids = val
    },
    SET_POST_MSG_UNREAD (state, val) {
      state.post_msg_unread = val
    },
    SET_USER_THEME_SETTING(state, val) {
      state.user_theme_setting = val
    },
    SET_AVATAR_MAIN_COLOR(state, val) {
      state.avatar_main_color = val
    },
    SET_BILIBILI_LIVING(state, val) {
      state.bilibili_living = val
    },
    SET_LAUGHTER_BLACKLIST(state, val) {
      state.laughter_blacklist = val
    },
    SET_MINI_PROGRAMS_FOLDERS(state, val) {
      state.mini_programs_folders = val
    },
    SET_STEAM_ID(state, val) {
      state.steam_id = val
    },
    SET_RECENT_MINI_PRO(state, val) {
      state.recent_mini_pro = val
    },
    SET_NEW_RECENT_MINI_PRO(state, val) {
      let newList = state.recent_mini_pro.filter(({mini_pro_id}) => val.mini_pro_id !== mini_pro_id)
      newList.unshift(val)
      state.recent_mini_pro = newList.slice(0, 5)
    },
    SET_USER_VERIFIED_STATUS(state, val) {
      state.user_verified_status = val
    },
  },
  actions: {

  }
}
export default User